// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { EducationType } from "../Data"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { Themes, iPhoneResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  education: EducationType
  nextExist: boolean
}

const BlockItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <div id={"date"}>{props.education.date}</div>
      <LineWrap>
        <ItemPoint>
          {props.education.isCode ? (
            <i className="fas fa-code" />
          ) : (
            <i className="fas fa-graduation-cap" />
          )}
        </ItemPoint>

        {props.nextExist && <ItemLine hideLine={false} />}
      </LineWrap>
      <TextWrap>{props.education.title} </TextWrap>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  margin-bottom: 42px;
  font-weight: bold;
  font-size: 18px;
  flex: 1;

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 12px;
  }
`

const TextWrap = styled.div`
  letter-spacing: 0.8px;
  text-align: left;
  font-size: 14px;
  color: #e6e6e6;
  flex: 9;
  line-height: 22px;

  @media (max-width: ${iPhoneResolution}px) {
    font-size: 12px;
    letter-spacing: 0.5px;
  }
`

const HORIZONTAL_MARGIN = 24
const MOBILE_REDUCED_WIDTH = 15
const LineWrap = styled.div`
  margin-right: ${HORIZONTAL_MARGIN}px;
  margin-left: ${HORIZONTAL_MARGIN}px;

  @media (max-width: ${iPhoneResolution}px) {
    margin-right: ${HORIZONTAL_MARGIN - MOBILE_REDUCED_WIDTH + 9}px;
    margin-left: ${HORIZONTAL_MARGIN - MOBILE_REDUCED_WIDTH}px;
  }
`

const ICON_SIZE = 40
const ItemPoint = styled.div`
  background-color: ${Themes.colors.primary};
  height: ${ICON_SIZE}px;
  width: ${ICON_SIZE}px;

  @media (max-width: ${iPhoneResolution}px) {
    height: ${ICON_SIZE - 15}px;
    width: ${ICON_SIZE - 15}px;
    margin-left: 8px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  filter: brightness(0.8);
  margin-top: -7px;
  margin-left: 2px;
`

const ItemLine = styled.div`
  height: 120%;
  width: 1px;
  background-color: gray;
  margin-left: ${ICON_SIZE / 2}px;
  opacity: ${(props: { hideLine: boolean }) => (props.hideLine ? 0 : 1)};
`

export default React.memo(BlockItem, memoComparison)
